export enum AuthMethods {
  ByCode = 1,
  ByPassword = 2,
}

export enum FormStates {
  RequestCode = 1,
  Login = 2,
}
